// Quiz routes live under /class. Centralized here so the header, footer, and
// guards read flow state from one place instead of each re-deriving it from
// path strings.

/** True on the quiz half of the site (vs. the ID-card half). */
export function isQuizHalf(pathname: string): boolean {
  return pathname.startsWith('/class');
}

/** True on a mid-progress screen where leaving loses work and warrants a
 * confirm: the quiz question stepper (/class/<n>) or the ID-card form/photo
 * steps. End screens (welcome / share / results / pickers) return false. */
export function isMidFlow(pathname: string): boolean {
  return /^\/class\/\d+$/.test(pathname) || pathname === '/id-card' || pathname === '/photo';
}
